module.exports = __webpack_public_path__ + "static/img/127.6bf0887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/127.png
// module id = u3Ue
// module chunks = 0